/*
  Brand pages: show product photos the way a studio cut-out would look.

  - A photo that already has a see-through background is shown as it is.
  - A photo on a white background has the white faded out, so the grey tile
    shows through. The fade is gradual: pure white disappears, soft shadows
    stay as shadows, clear glass becomes see-through, and anything darker or
    coloured is left exactly as it was.
  - The white is only faded where it connects to the edge of the photo, or
    where it forms a large enough pocket inside the product (inside a glass
    base, inside a hose loop).

  The pixel work runs in a background worker so the page never freezes while
  the photos are prepared.
*/
(function () {
  var TIMEOUT = 8000;   // never leave a photo hidden: show it as it is after this

  // Everything inside this function runs in the worker. It receives the
  // photo's pixels and answers with 'cutout' (leave as is), 'plain' (not a
  // white-background photo) or 'faded' plus the new pixels.
  function workerBody() {
    var LOW = 225;        // lightest tone that is always kept solid
    var STEP = 2;         // for white products: how big a jump in tone still counts as a soft shadow
    var PURE = 250;       // tone treated as plain white background
    var POCKET = 0.001;   // smallest enclosed white area to fade, as a share of the photo

    function prepare(px, w, h) {
      var total = w * h;

      // Already a cut-out: any see-through corner.
      var corners = [0, w - 1, (h - 1) * w, total - 1];
      for (var c = 0; c < corners.length; c++) {
        if (px[corners[c] * 4 + 3] < 20) return 'cutout';
      }

      // Lightest-channel value of a pixel (-1 when it is already see-through).
      var tone = function (k) {
        var o = k * 4;
        return px[o + 3] > 200 ? Math.min(px[o], px[o + 1], px[o + 2]) : -1;
      };

      // Is the product itself white? Mark the plain white that touches the
      // edge, then look at what is left: a white product is mostly off-white
      // with few pure-white gaps, whereas clear glass is full of pure white.
      var low = LOW, whiteProduct = false;
      (function () {
        var bg = new Uint8Array(total), stack = [], i, x, y, t, bgCount = 0, offWhite = 0, pure = 0;
        for (x = 0; x < w; x++) { stack.push(x, x + (h - 1) * w); }
        for (y = 0; y < h; y++) { stack.push(y * w, y * w + w - 1); }
        while (stack.length) {
          i = stack.pop();
          if (bg[i] || tone(i) < PURE) continue;
          bg[i] = 1; bgCount++;
          x = i % w;
          if (x > 0) stack.push(i - 1);
          if (x < w - 1) stack.push(i + 1);
          if (i >= w) stack.push(i - w);
          if (i < total - w) stack.push(i + w);
        }
        var product = total - bgCount;
        if (product <= 0) return;
        for (i = 0; i < total; i++) {
          if (bg[i]) continue;
          t = tone(i);
          if (t >= PURE) pure++;
          else if (t >= 235) offWhite++;
        }
        if (offWhite / product >= 0.3 && pure / product < 0.15) whiteProduct = true;
      })();

      // Spread outwards from the given starting points through light pixels.
      var fade = new Uint8Array(total), faded = 0;
      var spread = function (stack) {
        var i, x;
        while (stack.length) {
          i = stack.pop();
          if (fade[i] || tone(i) < low) continue;
          fade[i] = 1; faded++;
          x = i % w;
          if (x > 0) stack.push(i - 1);
          if (x < w - 1) stack.push(i + 1);
          if (i >= w) stack.push(i - w);
          if (i < total - w) stack.push(i + w);
        }
      };

      // White products: only follow gentle changes in tone. A soft shadow
      // fades gradually and is followed; the edge of the product is a sharper
      // step and stops the fade, so the product stays solid white.
      var spreadSmooth = function (stack) {
        var i, x, j, t, n4;
        for (j = 0; j < stack.length; j++) { if (!fade[stack[j]]) { fade[stack[j]] = 1; faded++; } }
        while (stack.length) {
          i = stack.pop();
          x = i % w;
          n4 = [x > 0 ? i - 1 : -1, x < w - 1 ? i + 1 : -1, i >= w ? i - w : -1, i < total - w ? i + w : -1];
          for (j = 0; j < 4; j++) {
            var m = n4[j];
            if (m < 0 || fade[m]) continue;
            t = tone(m);
            if (t >= PURE || (t >= LOW && t >= tone(i) - STEP)) { fade[m] = 1; faded++; stack.push(m); }
          }
        }
      };

      // 1. From the edges of the photo.
      var seeds = [], x, y, k;
      for (x = 0; x < w; x++) { seeds.push(x, x + (h - 1) * w); }
      for (y = 0; y < h; y++) { seeds.push(y * w, y * w + w - 1); }
      var edgeSeeds = [];
      for (k = 0; k < seeds.length; k++) { if (tone(seeds[k]) >= PURE) edgeSeeds.push(seeds[k]); }
      if (whiteProduct) spreadSmooth(edgeSeeds); else spread(edgeSeeds);
      if (faded / total < 0.05) return 'plain'; // not a white-background photo

      // 2. From pockets of plain white enclosed by the product.
      var visited = new Uint8Array(total), minPocket = Math.round(total * POCKET);
      for (var start = 0; start < (whiteProduct ? 0 : total); start++) {
        if (fade[start] || visited[start] || tone(start) < PURE) continue;
        var pocket = [start]; visited[start] = 1;
        for (k = 0; k < pocket.length; k++) {
          var n = pocket[k], nx = n % w;
          var around = [nx > 0 ? n - 1 : -1, nx < w - 1 ? n + 1 : -1, n >= w ? n - w : -1, n < total - w ? n + w : -1];
          for (var q = 0; q < 4; q++) {
            var m = around[q];
            if (m >= 0 && !fade[m] && !visited[m] && tone(m) >= PURE) { visited[m] = 1; pocket.push(m); }
          }
        }
        if (pocket.length >= minPocket) spread(pocket.slice());
      }

      // 3. Fade: the whiter the pixel, the more of the tile shows through.
      for (var i = 0; i < total; i++) {
        if (!fade[i]) continue;
        var o = i * 4;
        var a = Math.max(0, Math.min(1, (255 - tone(i)) / (255 - low)));
        if (a <= 0.004) { px[o + 3] = 0; continue; }
        for (var ch = 0; ch < 3; ch++) {
          px[o + ch] = Math.max(0, Math.min(255, Math.round((px[o + ch] - 255 * (1 - a)) / a)));
        }
        px[o + 3] = Math.round(255 * a);
      }
      return 'faded';
    }

    self.onmessage = function (e) {
      var d = e.data, px = new Uint8ClampedArray(d.buffer), result;
      try { result = prepare(px, d.w, d.h); } catch (err) { result = 'plain'; }
      self.postMessage({ id: d.id, result: result, buffer: d.buffer }, [d.buffer]);
    };
  }

  // One worker for the page; jobs are answered in the order they were sent.
  var worker = null, jobs = {}, nextId = 1;
  function getWorker() {
    if (worker) return worker;
    var code = '(' + workerBody.toString() + ')();';
    worker = new Worker(URL.createObjectURL(new Blob([code], { type: 'text/javascript' })));
    worker.onmessage = function (e) {
      var job = jobs[e.data.id];
      if (!job) return;
      delete jobs[e.data.id];
      job(e.data.result, e.data.buffer);
    };
    worker.onerror = function () {
      for (var id in jobs) { jobs[id]('plain'); }
      jobs = {};
    };
    return worker;
  }

  function process(img) {
    var card = img.closest('.bp-card__media');
    if (!card || card.dataset.tile) return;
    card.dataset.tile = 'pending';
    setTimeout(function () { if (card.dataset.tile === 'pending') card.dataset.tile = 'plain'; }, TIMEOUT);

    var source = new Image();
    source.crossOrigin = 'anonymous';
    source.onload = function () {
      try {
        var w = source.naturalWidth, h = source.naturalHeight;
        var canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(source, 0, 0);
        var data = ctx.getImageData(0, 0, w, h);
        var id = nextId++;
        jobs[id] = function (result, buffer) {
          if (card.dataset.tile !== 'pending') return;
          if (result !== 'faded' || !buffer) { card.dataset.tile = result === 'cutout' ? 'cutout' : 'plain'; return; }
          ctx.putImageData(new ImageData(new Uint8ClampedArray(buffer), w, h), 0, 0);
          canvas.toBlob(function (blob) {
            if (card.dataset.tile !== 'pending') return;
            if (!blob) { card.dataset.tile = 'plain'; return; }
            img.removeAttribute('srcset');
            img.src = URL.createObjectURL(blob);
            card.dataset.tile = 'cutout';
          }, 'image/png');
        };
        getWorker().postMessage({ id: id, w: w, h: h, buffer: data.data.buffer }, [data.data.buffer]);
      } catch (e) {
        card.dataset.tile = 'plain';
      }
    };
    source.onerror = function () { card.dataset.tile = 'plain'; };
    source.src = img.currentSrc || img.src;
  }

  function start() {
    document.documentElement.classList.add('bp-ready');
    var images = document.querySelectorAll('.brand-page .bp-card__media img');
    if (!('Worker' in window) || !('IntersectionObserver' in window)) {
      images.forEach(function (img) { var card = img.closest('.bp-card__media'); if (card) card.dataset.tile = 'plain'; });
      return;
    }
    var watcher = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { watcher.unobserve(entry.target); process(entry.target); }
      });
    }, { rootMargin: '900px' });
    images.forEach(function (img) { watcher.observe(img); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
